module.exports = require("rxjs/Subject");


//////////////////
// WEBPACK FOOTER
// external "rxjs/Subject"
// module id = 63
// module chunks = 0